import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchInternalRepatriationsTransactions = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getInternalRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
    queryStringParams: {
      impcCode: payload.params.impcCode,
      dayCount: payload.params.dayCount,
      transactionCode: payload.params.transactionCode,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchInternalRepatriationsTransactions;
